import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'

import { createApp } from 'utils/io'
import { defaultBranding } from 'utils/colors'
import { verifyXanoApp } from 'utils/externalDatabases'
import { getNewAppWebSettings } from 'utils/webSettings'

import { getApp } from 'ducks/apps'

import Modal from 'components/Shared/Modal'

import CopyAppForm from './Form'

class CopyApp extends Component {
  handleSubmit = async formValues => {
    const { app } = this.props

    if (!app) {
      return
    }

    const {
      id: appId,
      branding = {},
      webSettings: sourceWebSettings,
      OrganizationId,
      useNewRNVersion,
      useNewArchitecture,
    } = app

    let { copyAsResponsive, appType, ...values } = formValues
    let mobileOnly = false

    if (appType) {
      copyAsResponsive = appType !== 'legacy'
      mobileOnly = appType === 'mobile'
    }

    const magicLayout = app?.magicLayout || copyAsResponsive

    const primaryPlatform = copyAsResponsive
      ? 'responsive'
      : app.primaryPlatform

    const webSettings = getNewAppWebSettings({
      sourceWebSettings,
      primaryPlatform,
      mobileOnly,
    })

    let opts = {
      ...values,
      branding: {
        ...defaultBranding,
        ...branding,
      },
      primaryPlatform,
      prototypeAppId: appId,
      magicLayout,
      webSettings,
      useNewRNVersion,
      useNewArchitecture,
    }

    if (values.copyDatabase === '0') {
      opts = {
        ...values,
        branding: {
          ...defaultBranding,
          ...branding,
        },
        primaryPlatform,
        datasourceAppId: appId,
        copyApp: true,
        copyDatabase: undefined,
        datasourceType: 'copy',
        magicLayout,
        webSettings,
        organizationId: OrganizationId,
        useNewRNVersion,
        useNewArchitecture,
      }
    }

    if (app.externalUsers?.enabled && app.externalUsers?.provider === 'xano') {
      opts.datasourceType = 'xano'
    }

    createApp(opts, error => {
      if (error) {
        toast.error(
          typeof error === 'string'
            ? error
            : 'Failed to copy app. Please try again.',
          {
            position: 'bottom-right',
            className: 'generic-error__toast',
            bodyClassName: 'generic-error__toast-body',
            hideProgressBar: true,
            autoClose: 5000,
          }
        )
      }
    })

    return this.handleCancel()
  }

  handleCancel = () => {
    const { match, history } = this.props
    const { appId } = match.params

    history.push(`/apps/${appId}/screens`)
  }

  render() {
    const { app } = this.props
    const isXanoApp = verifyXanoApp(app)
    const isResponsiveApp = app?.magicLayout
    const primaryPlatform = app?.primaryPlatform

    if (!app) {
      return null
    }

    const initialValues = {
      name: `${app.name} Copy`,
      copyAsResponsive: false,
      organizationId: app.OrganizationId,
      copyDatabase: '1',
    }

    if (primaryPlatform !== 'responsive') {
      initialValues.appType = 'legacy'
    }

    return (
      <Modal>
        <CopyAppForm
          onSubmit={this.handleSubmit}
          onCancel={this.handleCancel}
          initialValues={initialValues}
          isXanoApp={isXanoApp}
          isResponsiveApp={isResponsiveApp}
          primaryPlatform={primaryPlatform}
        />
      </Modal>
    )
  }
}

const mapStateToProps = (state, { match }) => ({
  app: getApp(state, match.params.appId),
})

export default connect(mapStateToProps)(CopyApp)
